import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'name',
      type: 'input',
      label: '部门名',
      placeholder: '请输入部门名',
      rules: { required: true, message: '部门名是必传的', trigger: 'blur' }
    },
    {
      field: 'seq',
      type: 'input',
      label: '排序',
      placeholder: '请输入排序值 0-9 之间',
      rules: { required: true, message: '排序必传的', trigger: 'blur' }
    },
    {
      field: 'chargePerson',
      type: 'input',
      label: '负责人',
      placeholder: '请输入负责人'
    },
    {
      field: 'pid',
      type: 'cascader',
      label: '上级部门',
      placeholder: '请选择上级部门',
      otherOptions: {
        'show-all-levels': false,
        clearable: true,
        props: {
          checkStrictly: true,
          value: 'id',
          label: 'name',
          children: 'children',
          emitPath: false
        }
      }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
